<template>
  <div class="Bom flex-column">
    <div class="page-title">{{ title }}</div>
    <div class="flex flex-auto">
      <div class="tree-container">
        <AProductTypeTreeSelector @select="handleSelectProductType" />
      </div>
      <div style="width:calc(100% - 170px);">
        <ATable
          v-loading="loading"
          ref="table"
          class-search-container="searchContainer"
          :placeholder="placeholder"
          :search_field="search_field"
          :data="items"
          :exportExcel="handleClickExcel"
          border
          hide-button-insert
          @cell-click="handleClickCell"
        >
          <div slot="search" class="inline">
            <div class="inline">
              <el-select
                size="mini"
                v-model="search_sale_type_id"
                :placeholder="$t('lang.sales_classification')"
              >
                <el-option :key="0" :value="0" label="전체" />
                <el-option
                  v-for="item in table_sale_type"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="inline pl-default">
              <el-checkbox v-model="search_only_register"
                >등록건만 보기</el-checkbox
              >
            </div>
          </div>
          <el-table-column
            type="index"
            label="No"
            :index="handleIndex"
            :width="$width.indexw"
          />
          <el-table-column prop="code" :label="$t('lang.code')" width="80" />
          <el-table-column
            prop="sale_type_id"
            width="80"
            :label="$t('lang.sales_classification')"
            :formatter="resolveSaleTypeFlag"
          />
          <el-table-column prop="name" label="품목명" show-overflow-tooltip />
          <el-table-column
            prop="size"
            label="규격"
            width="100"
            show-overflow-tooltip
          />
          <el-table-column
            prop="categories"
            width="150"
            show-overflow-tooltip
            label="제품구분"
            :formatter="resolveCategoriesFlag"
          />
          <el-table-column
            prop="unit_id"
            width="60"
            :label="$t('lang.unit')"
            :formatter="resolveUnitsFlag"
          />
          <el-table-column
            prop="bom_use_flag"
            :label="$t('lang.state')"
            width="60"
            :formatter="
              (row, cell, cellValue) =>
                cellValue === 'Y'
                  ? '사용'
                  : cellValue === 'N'
                  ? '미사용'
                  : '없음'
            "
          />
          <el-table-column
            prop="kind"
            label="기계"
            width="60"
            :formatter="
              (row, cell, cellValue) => (cellValue === 'GOODS' ? '표기' : ' ')
            "
          />
          <el-table-column
            prop="desc"
            :label="$t('lang.desc')"
            show-overflow-tooltip
          />
          <el-table-column
            prop="bom_flag"
            label="등록"
            width="60"
            class-name="align-center"
          >
            <template slot-scope="scope">
              <el-popover
                ref="popover"
                placement="bottom"
                width="240"
                trigger="click"
              >
                <ATable
                  :data="assemble_items"
                  hide-top-panel
                  hide-button-insert
                  hide-pagination
                >
                  <el-table-column prop="code" label="코드" width="80px" />
                  <el-table-column
                    prop="name"
                    label="품목명"
                    show-overflow-tooltip
                  />
                </ATable>
                <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-setting"
                  @click="handleClickViewAssemble(scope.row)"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="조회" width="60" class-name="align-center">
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.bom_use_flag === 'Y' && scope.row.bom_details_length
                "
                size="mini"
                icon="el-icon-search"
                @click="handleClickViewBOM(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="created_user_name"
            :label="$t('lang.created_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="modified_user_name"
            :label="$t('lang.modified_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="created_at"
            :label="$t('lang.created_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <el-table-column
            prop="modified_at"
            :label="$t('lang.modified_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
        </ATable>
      </div>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="1200px"
      destroyOnClose
      title="BOM 등록"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <BomForm
        ref="form"
        v-if="dialog_visible"
        :data="selected_data"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      destroyOnClose
      title="BOM 조회"
      :visible.sync="dialog2_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened('form2')"
    >
      <BomView
        ref="form2"
        v-if="dialog2_visible"
        :data="selected_data"
        @completed="handleCompletedViewBOM"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      title="BOM 다운로드"
      width="280px"
      :visible.sync="dialog3_visible"
      destroyOnClose
    >
      <div class="flex">
        <div>
          <el-button @click="handleClickDetailDownload"
            >상세 다운로드</el-button
          >
          <AHelper>BOM 상세 목록을 다운로드합니다.</AHelper>
        </div>
        <div class="ml-default">
          <el-button @click="handleClickProductDownload"
            >품목 다운로드</el-button
          >
          <AHelper
            >BOM 등록여부가 포함 된 품목 리스트를 다운로드합니다.</AHelper
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import export2csv from "@/common/function/export2csv";
import BomForm from "./BomForm";
import BomView from "./BomView";

export default {
  name: "Bom",
  mixins: [form_container, authority_level],
  components: { BomForm, BomView },
  data() {
    return {
      loading: false,
      title: this.$t("title.bom"),
      placeholder: "코드, 품목명, 규격, 비고",
      search_field: ["code", "name", "size", "desc"],
      search_type_id: 0,
      search_sale_type_id: 0,
      search_only_register: false,
      selected_data: undefined,
      dialog_visible: false,
      dialog2_visible: false,
      dialog3_visible: false,
      assemble_items: [],
      loading_assemble: false,
      items: [],
      bom_data: [],
      origin_items: [],
    };
  },
  computed: {
    ...mapGetters([
      "table_product",
      "table_product_type",
      "table_product_category",
      "table_product_option",
      "table_sale_type",
      "table_unit",
      "table_product_price",
    ]),
    has_grant_write() {
      return this.isWriteLevel("bom");
    },
  },
  watch: {
    table_product() {
      this.search_type_id = null;
      this.search_sale_type_id = null;
      this.search_only_register = null;
      this.loadBomData();
    },
    search_only_register(value) {
      this.items = this.origin_items.filter((item) =>
        value ? item.bom_use_flag === "Y" : true
      );
    },
    search_sale_type_id(value) {
      this.items = this.origin_items.filter((item) =>
        value ? item.sale_type_id === value : true
      );
    },
    search_type_id(value) {
      this.items = this.origin_items.filter((item) =>
        value ? item.type_id === value : true
      );
    },
    origin_items(value) {
      this.items = value;
    },
  },
  mounted() {
    this.loadBomData();
  },
  methods: {
    async loadBomData() {
      this.loading = true;
      const res = await this.api.listBOM();
      this.loading = false;
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      const bom_data = res.data;
      const items = this.table_product
        .filter((item) => {
          return (
            (this.search_type_id > 0
              ? item.type_id === this.search_type_id
              : true) &&
            (this.search_sale_type_id > 0
              ? item.sale_type_id === this.search_sale_type_id
              : true) &&
            (this.search_only_register ? item.bom_use_flag === "Y" : true) &&
            item.is_hide === "N"
          );
        })
        .sort(this.util.sortByName);
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const bom = bom_data.find((d) => d.product_id === item.id);
        if (!bom) {
          item.bom_use_flag = null;
          item.bom_details_length = 0;
        } else {
          item.bom_use_flag = bom.details.length ? bom.use_flag : null;
          item.bom_details_length = bom.details.length;
        }
      }
      this.origin_items = items;
      // this.items = items;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    /** 데이터 선택 */
    handleClickCell(data, column) {
      // if( !this.has_grant_write() ) return;

      if (!column.property) {
        return;
      }
      if (column.property === "bom_flag") {
        return;
      }
      this.selected_data = data;
      this.dialog_visible = true;
    },
    /**  폼 처리 완료 */
    handleCompleted(message, data) {
      this.dialog_visible = false;
      const itemIndex = this.items.findIndex((x) => x.id === data.product_id);
      this.items[itemIndex].bom_use_flag = data.bom_use_flag;
      this.items[itemIndex].bom_details_length = data.bom_details_length;
      // this.loadBomData();
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    handleCompletedViewBOM() {
      this.dialog2_visible = false;
    },
    handleSelectProductType(value) {
      this.search_type_id = value;
    },
    handleClickViewBOM(data) {
      this.selected_data = data;
      this.dialog2_visible = true;
    },
    handleClickViewAssemble(data) {
      this.loading_assemble = true;
      this.api.listBOMAssemble(data).then((res) => {
        this.loading_assemble = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.assemble_items = res.data;
      });
    },
    /** 단위 필터(Unit filter) */
    resolveUnitsFlag(row, column, value) {
      const type = this.table_unit.filter((f) => f.id === value);
      if (type.length > 0) return type ? type[0].name : "";
    },
    resolveSaleTypeFlag(row, column, value) {
      const type = this.table_sale_type.filter((f) => f.id === value);
      if (type.length > 0) return type ? type[0].name : "";
    },
    resolveTypesFlag(row, column, value) {
      const type = this.table_product_type.filter((f) => f.id === value);
      if (type.length > 0) return type ? type[0].name : "";
    },
    resolveCategoriesFlag(row, column, value) {
      if (!value) {
        return "";
      }
      const arrStr = [];
      value.map((item) => {
        const type = this.table_product_category.filter(
          (f) => f.id === item.product_category_id
        );
        if (type.length > 0) arrStr.push(type ? type[0].name : "");
      });
      return arrStr.join(",");
    },
    // resolveView(row) {
    //   return this.regItems.includes(row.id);
    // },
    optionsFormat(row, cell, cellValue) {
      let options = cellValue.map((option) => option.product_option_id);
      options = this.table_product_option.filter(
        (option) => options.indexOf(option.id) > -1
      );
      options = options.map((option) => option.name);
      return options.join(", ");
    },
    handleClickExcel() {
      this.dialog3_visible = true;
    },
    handleClickDetailDownload() {
      this.dialog3_visible = false;
      this.loadBOMDetailForExcel();
    },
    handleClickProductDownload() {
      this.dialog3_visible = false;
      this.$refs.table.downloadExcel();
    },
    loadBOMDetailForExcel() {
      this.api.listBOM().then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.downloadExcelDetail(res.data);
      });
    },
    downloadExcelDetail(items) {
      let fields = [
        { label: "No", value: "index" },
        { label: "품목", value: "name" },
        { label: "규격", value: "size" },
        { label: "기본가", value: "price" },
        { label: "Seq", value: "seq" },
        { label: "BOM 품목", value: "bom_name" },
        { label: "BOM 규격", value: "bom_size" },
        { label: "BOM 규격", value: "bom_size" },
        { label: "BOM 수량", value: "bom_amount" },
        { label: "BOM 기본가", value: "bom_price" },
        { label: "BOM 비고", value: "bom_detail" },
      ];
      let index = 1;
      let data = [];
      let product1, product2, price1, price2;
      let seq;
      items.forEach((item) => {
        product1 = this.table_product.find((p) => p.id === item.product_id);
        if (!product1) {
          return true;
        }
        price1 = this.table_product_price.find(
          (p) => p.product_id === item.product_id
        );
        seq = 1;
        item.details.forEach((d) => {
          product2 = this.table_product.find((p) => p.id === d.product_id);
          if (!product2) {
            return true;
          }
          price2 = this.table_product_price.find(
            (p) => p.product_id === d.product_id
          );
          data.push({
            index: index,
            name: product1.name,
            size: product1.size,
            price: price1 ? price1.price : "",
            seq: seq,
            bom_name: product2.name,
            bom_size: d.size,
            bom_amount: d.amount,
            bom_price: price2 ? price2.price : "",
            bom_detail: d.desc,
          });
          seq++;
          index++;
        });
      });
      export2csv.export(data, fields, "BOM_Detail.xls");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.tree-container {
  width: 160px;
  overflow: auto;
  flex: 0 0 160px;
  margin-right: 10px;
  border: $border-dark;
}
</style>
